import "../../components/style.css";
import Spline from '@splinetool/react-spline';

const stats = [
  { label: "Founded", value: "2021" },
  { label: "Employees", value: "5" },
  { label: "Beta Users", value: "521" },
  { label: "Raised", value: "$25M" },
];






export default function Mint() {
  return (
    <div className="relative py-16 sm:py-24  bg-neutral-900">
      <div class=" animation-wrapper">
        <div class="particle particle-1"></div>
      </div>
      <div className="lg:mx-auto lg:grid lg:max-w-7xl lg:grid-cols-1 lg:items-start lg:gap-24 lg:px-8">
        <div className="relative mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:px-0">
          {/* Content area */}

          <div className="sm:pt-16 lg:pt-0 pt-4">
            <h2 className="text-3xl font-bold tracking-tight text-gray-100 sm:text-4xl text-left font-mono">
              MORPHOSIS 🌱
            </h2>
            <div className="mt-6 space-y-6 text-gray-100">
              <p className="text-base leading-7 text-left font-mono text-justify">
              …Existen rumores de qué habrá dentro de la caja. Algunos tripulantes esperan encontrar una peluca con un buen spray para el cabello, otros un gatito, entre otros comentarios…Lo que sí es seguro es que muchos esperan encontrar la sabiduría a través de Elysium.
              </p>
              <p className="text-base leading-7 text-left font-mono text-justify">
              Luego de realizar el primer aterrizaje en la constelación Ethereum, Cryptonikas marca el rumbo a la constelación de Polygon, junto a todos los cosmonautas con sus cajas para cimentar una segunda base cryptonika, expandir el conocimiento y continuar el propósito de construir juntos.
              </p>
              <p className="text-base leading-7 text-left font-mono text-justify">
              Al bajar de la nave nodriza, festejando éste logro, suena de fondo una canción que hace bailar a todos elevando energías, y se anuncia que finalmente ha llegado el momento cryptoniko para descubrir lo que hay en el interior de las cajas.
              </p>
              <p className="text-base leading-7 text-left font-mono text-justify">
              Elysium tiene la habilidad de percibir la energía de cada tripulante y dependiendo de su vibración recibirán uno de los siguientes objetos:
              </p>
              <p className="text-base leading-7 text-left font-mono text-justify">
              Un orbis: Un ente radiante de luz de forma circular, envuelto en pequeños fragmentos morados, el cual concede el poder visual, ondas y velocidad de la luz.
              </p>
              <p className="text-base leading-7 text-left font-mono text-justify">
              Un opal: Un control lleno de botones con infinitas posibilidades sonoras, otorgando el poder sónico, ondas y velocidad del sonido.
              </p>
              <p className="text-base leading-7 text-left font-mono text-justify">
              Estos objetos son la fuente de poder para activar sus naves y continuar la aventura hacia nuevas misiones, recordándoles que deben guardar en un lugar preciado sus cajas Elysium, ya que en un futuro podrían encontrar dentro de ellas herramientas que los ayuden en sus misiones.
              </p>
              <p className="text-base leading-7 text-left font-mono text-justify">
              ¡Tripulantes! Damos hoy un paso más para compartir el conocimiento, expandirlo y liberar a otros humanos…
              </p>
              <p className="text-base leading-7 text-left font-mono text-justify">
              Activen sus naves, ¡las misiones nos esperan!
              </p>
              <p className="text-base leading-7 text-left font-mono text-justify">
              Continuará…
              </p>
            </div>

           {/*  <div>
              <a
                href="https://opensea.io/collection/cryptonikas-dao-v2"
                _target="blank"
                className="mt-10 mb-10 whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-full shadow-sm text-base font-medium text-white bg-violet-600 hover:bg-violet-800"
              >
                OpenSea Collection
              </a>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
